import React from 'react';
import SimpleWISCVSystem from '../SimpleWISCVSystem';
import '../simple-styles.css';

/**
 * Legacy wrapper component that preserves the original WISC-V system
 * Available at route: /
 */
const LegacyApp: React.FC = () => {
  return <SimpleWISCVSystem />;
};

export default LegacyApp;
